import {useState,useEffect} from 'react'

export default(url) => {
    const [pokemons,setPokemons] = useState(null)
    const [loading,setLoading] = useState(true)
    const [error,setError] = useState(null)

    useEffect(()=>{
        fetch(url)
        .then(resp => resp.json())
        .then(data=>{
          setPokemons(data)
        })
        .catch(err=>{
          setError(err)
        })
        .finally(()=>{
          setLoading(false)
        })
    },[url])

    return {
        pokemons,
        loading,
        error
    }
}